import { rgba } from 'polished';
import styled, { css, DefaultTheme } from 'styled-components';

type ButtonProps = {
  variant: 'primary' | 'secondary' | 'inverted';
  size: 'small' | 'medium' | 'large';
};

const buttonThemes = (theme: DefaultTheme) => ({
  primary: {
    highlight: theme.colors.primary10,
    background: theme.colors.primary70,
    player: theme.colors.globalWhite100,
  },
  secondary: {
    highlight: rgba(theme.colors.primary20, 0.2),
    background: theme.colors.secondary50,
    player: theme.colors.globalWhite100,
  },
  inverted: {
    highlight: theme.colors.primary10,
    background: theme.colors.primary20,
    player: theme.colors.primary70,
  },
});

const buttonSizes = {
  small: {
    button: 28,
    container: 36,
    player: 12,
  },
  medium: {
    button: 32,
    container: 48,
    player: 12,
  },
  large: {
    button: 62,
    container: 110,
    player: 24,
  },
};

export const Button = styled.button<ButtonProps>`
  ${({ theme, variant, size }) => css`
    width: ${buttonSizes[size].button}px;
    height: ${buttonSizes[size].button}px;
    background-color: ${buttonThemes(theme)[variant].background};

    margin: 0;
    padding: 0;
    border: none;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
  `}
`;

const highlightModifiers = {
  small: css`
    animation: 1.5s infinite ease-in-out smallAnimation;

    @keyframes smallAnimation {
      from {
        border-width: 0px;
      }

      50% {
        border-width: 4px;
      }

      to {
        border-width: 0px;
      }
    }
  `,
  medium: css`
    animation: 1.5s infinite ease-in-out mediumAnimation;

    @keyframes mediumAnimation {
      from {
        border-width: 0px;
      }

      50% {
        border-width: 8px;
      }

      to {
        border-width: 0px;
      }
    }
  `,
  large: css`
    animation: 1.5s infinite ease-in-out largeAnimation;

    @keyframes largeAnimation {
      from {
        border-width: 0px;
      }

      50% {
        border-width: 24px;
      }

      to {
        border-width: 0px;
      }
    }
  `,
};

export const ButtonHighlight = styled.div<ButtonProps>`
  ${({ theme, variant, size }) => css`
    display: inline-block;
    border-radius: 50%;
    border: 1px solid ${buttonThemes(theme)[variant].highlight};

    ${highlightModifiers[size]}
  `}
`;

export const ButtonContainer = styled.div<Partial<ButtonProps>>`
  height: 48px;
  width: 48px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Play = styled.div<ButtonProps>`
  ${({ theme, variant, size }) => css`
    svg {
      height: ${buttonSizes[size].player}px;
      width: ${buttonSizes[size].player}px;

      color: ${buttonThemes(theme)[variant].player};

      margin-top: -1px;
    }
  `}
`;
